import isEqual from 'lodash.isequal';
const columns = 5;

function trackAction(action, slideId) {
  if (window && window.NREUM) {
    const articleId = document.querySelector('meta[name="article.id"]');
    const metaType = document.querySelector('meta[name="article.type"]');
    const metaSection = document.querySelector('meta[name="article.section"]');
    const pageSource = document.querySelector('meta[name="page.content.source"]');

    const data = {
      insetName: 'gerrymander',
      articleId: articleId ? articleId.getAttribute('content') : '',
      articleType: metaType ? metaType.getAttribute('content') : '',
      articleSection: metaType ? metaSection.getAttribute('content') : '',
      pageSource: pageSource ? pageSource.getAttribute('content') : '',
      slideId
    }

    window.NREUM.addPageAction(
      `gerrymander:${action}`,
      data
    );
  }
}

function isValidAnswer(answers, outcomes, num_squares){
  const totals = {};
  const winner = [];

  const districts = answers.reduce((prev, next, index) => {
    if (next.district in prev) {
      prev[next.district] = [...prev[next.district], next.id];
    }
    else {
      prev[next.district] = [next.id];
    }

    return prev;
  }, {});

  Object.keys(districts).forEach((district) => {
    Object.keys(outcomes).forEach(outcomesKey => {
      outcomes[outcomesKey].forEach((outcome, i) => {
        const areEqual = isEqual(districts[district].sort(), outcome.sort());

        if(areEqual){
          if(totals[outcomesKey]){
            totals[outcomesKey] = [...totals[outcomesKey], areEqual];
          } else {
            totals[outcomesKey] = [areEqual];
          }
        }
      });
    });
  });

  Object.keys(totals)
    .forEach(totalsKey => {
      if(totals[totalsKey].length === Object.keys(districts).length) {
        winner.push(true);
      } else {
        winner.push(false);
      }
    });

  if(winner.some(item => item)){
    return true;
  } else {
    return false;
  }
}

function setId(actionId, state){
  const [challenge, type] = actionId.split('.');

  if(type === 'check'){
    const answers = state.activeSlide.game_info.answers;
    const possibleOutcomes = state.activeSlide.game_info.outcomes;
    const num_squares = state.activeSlide.game_info.num_squares;
    const yourDistricts = state.activeSlide.game_info.yourDistricts;

    if(isValidAnswer(answers, possibleOutcomes, num_squares)){
      trackAction('answer:correct', `${challenge}.challenge`);
      return Object.assign({}, {
        id: `${challenge}.results-success`,
        yourDistricts: yourDistricts,
        num_squares
      });
    } else {
      trackAction('answer:incorrect', `${challenge}.challenge`);
      return Object.assign({}, {
        id: `${challenge}.results-error`,
        yourDistricts: yourDistricts,
        num_squares
      });
    }
  }

  return Object.assign({}, {
    id: actionId
  });
}

function isAdjacent(square, squares, activeDistrict, num_squares) {
  if(!activeDistrict || activeDistrict.length === num_squares){
    return true;
  }

  var collection = activeDistrict.map(item => {
    if (nextToOrBelow(square, item)) {
      return true;
    }

    if(item.owns){
      const owned = squares.find(s => s.id === item.owns);

      if (nextToOrBelow(square, owned)) {
        return true;
      }
    }

    if(square.owns){
      const owned = squares.find(s => s.id === square.owns);

      if (nextToOrBelow(owned, item)) {
        return true;
      }
    }

    if(square.owns && item.owns) {
      const owned = squares.find(s => s.id === square.owns);
      const ownedNeighbor = squares.find(s => s.id === item.owns);
      if (nextToOrBelow(owned, ownedNeighbor)) {
        return true;
      }
    }

    return false;
  });

  return collection.some(item => item);
}

function findSlide(slides, info){
  const { id, yourDistricts, num_squares } = info;
  const [challenge, type] = id.split('.');
  const activeSlide = slides.find(item => {
    return item.challenge === +challenge && item.type === type;
  });

  return Object.assign({}, activeSlide, {
    yourDistricts,
    num_squares
  });
}

function nextToOrBelow(square, item){
  // make sure the items are on the same row
  if(square.id + 1 === item.id && (Math.ceil(square.id / columns) === Math.ceil(item.id / columns))) {
    return true;
  }
  if(square.id - 1 === item.id && (Math.ceil(square.id / columns) === Math.ceil(item.id / columns))) {
    return true;
  }
  if(square.id + 5 === item.id) {
    return true;
  }
  if(square.id - 5 === item.id) {
    return true;
  }
  return false;
}

function calcYourDistricts(answers){
  return answers.reduce((prev, next) => {
    const key = `district-${next.district - 1}`;
    if (key in prev) {
      if(prev[key][next.party]){
        prev[key][next.party] = prev[key][next.party] + 1;
      } else {
        prev[key] = Object.assign({}, prev[key], {
          [next.party] : 1
        });
      }
    }
    else {
      prev[key] = {
        [next.party] : 1
      };
    }

    return prev;
  }, {});
}

function isSelected(answers, square){
  const values = []
  answers.forEach(answer => {
    values.push(answer.id === square.id);
  });

  if(values.some(item => item)){
    return true;
  } else {
    return false;
  }
}

export {
  calcYourDistricts,
  findSlide,
  isAdjacent,
  isSelected,
  isValidAnswer,
  nextToOrBelow,
  setId,
  trackAction
}



// WEBPACK FOOTER //
// ./src/utils.js